export const CONNECTION_GAMES = [
  [
    {
      category: "Types of Pasta",
      words: ["Fusilli", "Rigatoni", "Gnocchi", "Orzo"],
      difficulty: 1,
    },
    {
      category: "Capital Cities",
      words: ["Canberra", "Ottawa", "Sofia", "Bern"],
      difficulty: 2,
    },
    {
      category: "Famous Inventors",
      words: ["Edison", "Tesla", "Bell", "Ford"],
      difficulty: 3,
    },
    {
      category: "Classical Composers",
      words: ["Mozart", "Bach", "Chopin", "Handel"],
      difficulty: 4,
    },
  ],
  [
    {
      category: "Board Games",
      words: ["Cluedo", "Risk", "Monopoly", "Uno"],
      difficulty: 1,
    },
    {
      category: "Types of Rock",
      words: ["Igneous", "Sedimentary", "Obsidian", "Graphite"],
      difficulty: 2,
    },
    {
      category: "Shakespeare Plays",
      words: ["Othello", "Macbeth", "Lear", "Faustus"],
      difficulty: 3,
    },
    {
      category: "Famous Rivers",
      words: ["Amazon", "Danube", "Volga", "Everest"],
      difficulty: 4,
    },
  ],
  [
    {
      category: "Units of Measurement",
      words: ["Yard", "Stone", "Ounce", "Litre"],
      difficulty: 1,
    },
    {
      category: "Types of Dance",
      words: ["Salsa", "Waltz", "Tango", "Foxtrot"],
      difficulty: 2,
    },
    {
      category: "British Slang",
      words: ["Quid", "Loo", "Guv", "Bloke"],
      difficulty: 3,
    },
    {
      category: "Heavy Metal Bands",
      words: ["Slipknot", "Korn", "Tool", "Pantera"],
      difficulty: 4,
    },
  ],
  [
    {
      category: "Card Games",
      words: ["Bridge", "Poker", "Rummy", "Snap"],
      difficulty: 1,
    },
    {
      category: "Shades of Green",
      words: ["Mint", "Olive", "Lime", "Emerald"],
      difficulty: 2,
    },
    {
      category: "Birds",
      words: ["Wren", "Jay", "Robin", "Finch"],
      difficulty: 3,
    },
    {
      category: "Types of Bridges",
      words: ["Suspension", "Arch", "Beam", "Truss"],
      difficulty: 4,
    },
  ],
  [
    {
      category: "Black Women Authors",
      words: ["Toni", "Paule", "Zora", "Alice"],
      difficulty: 1,
    },
    {
      category: "Michael ____",
      words: ["Jackson", "Jordan", "Johnson", "Tyson"],
      difficulty: 2,
    },
    {
      category: "Black Greek Sorority Symbols",
      words: ["Poodle", "Dove", "Ivy", "Pyramid"],
      difficulty: 3,
    },
    {
      category: "Boyz II Men",
      words: ["Michael", "Nathan", "Wanyá", "Shawn"],
      difficulty: 4,
    },
  ],
  [
    {
      category: "Countries in West Africa",
      words: ["Nigeria", "Cameroon", "Togo", "Benin"],
      difficulty: 1,
    },
    {
      category: "Countries in East Africa",
      words: ["Tanzania", "Kenya", "Ethiopia", "Somalia"],
      difficulty: 2,
    },
    {
      category: "Countries in North Africa",
      words: ["Morocco", "Algeria", "Tunisia", "Libya"],
      difficulty: 3,
    },
    {
      category: "African Islands",
      words: ["Madagascar", "Mauritius", "Comoros", "Mayotte"],
      difficulty: 4,
    },
  ],
  [
    {
      category: "California Rappers",
      words: ["O'Shea", "Eric", "Lesane", "Todd"],
      difficulty: 1,
    },
    {
      category: "Black Founded Clothing Brands",
      words: ["Fubu", "Phat Farm", "Enyce", "Rocawear"],
      difficulty: 2,
    },
    {
      category: "Hair Cut Styles",
      words: ["Ceasar", "Wavelength", "Fade", "Taper"],
      difficulty: 3,
    },
    {
      category: "Black Mayors",
      words: ["Bass", "Turner", "Adams", "Washington"],
      difficulty: 4,
    },
  ],
  [
    {
      category: "Church Leadership Roles",
      words: ["Deacon", "Elder", "Minister", "Pastor"],
      difficulty: 1,
    },
    {
      category: "Synonyms for Lucky",
      words: ["Blessed", "Fortunate", "Favored", "Providential"],
      difficulty: 2,
    },
    {
      category: "R&B Icons",
      words: ["Tyrese", "Usher", "Brandy", "Maxwell"],
      difficulty: 3,
    },
    {
      category: "Tupac's Movie Character Names",
      words: ["Bishop", "Lucky", "Birdie", "Tank"],
      difficulty: 4,
    },
  ],
  [
    {
      category: "Slang for 'A Lot'",
      words: ["Bare", "Mad", "Hella", "Buku"],
      difficulty: 1,
    },
    {
      category: "Slang for 'Great'",
      words: ["Cold", "Raw", "Dope", "Lit"],
      difficulty: 2,
    },
    {
      category: "Ways to Refer to Money",
      words: ["Brick", "Band", "Rack", "C-Note"],
      difficulty: 3,
    },
    {
      category: "Things Needed to Make a Pizza",
      words: ["Cheddar", "Dough", "Sauce", "Heat"],
      difficulty: 4,
    },
  ],
  [
    {
      category: "Boondocks Characters",
      words: ["Riley", "Huey", "Jazmine", "Robert"],
      difficulty: 1,
    },
    {
      category: "Uncle ____",
      words: ["Ruckus", "Tom", "Luke", "Ben's"],
      difficulty: 2,
    },
    {
      category: "Bobby ____",
      words: ["Brown", "Womack", "Schmurda", "Valentino"],
      difficulty: 3,
    },
    {
      category: "Black Panther Leadership",
      words: ["Bobby", "Fred", "Elaine", "Kathleen"],
      difficulty: 4,
    },
  ],
];